<template>
    <div class="ScenarioNodeSelector">
        <div style="display: flex; align-items: center">
            <!--Filter by type node-->
            <div style="width: 250px; margin-right: 8px">
                <v-select
                    hide-details outlined
                    v-model="searchType"
                    :placeholder="$f.tc('type') + ' ' + $t('bot')"
                    :items="nodeTypes"
                    class="input-custom"
                    item-text="name"
                    item-value="type"
                    @change="searchText = ''"
                    clearable
                >
                    <template v-slot:item="{ item }">
                        <div class="item-type">
                            <div style="width: 40px; text-align: center">
                                <img :src="NodeIconMap[item.type]" style="margin-right: 8px" :style="{transform: `scale(${item.scale})`}">
                            </div>
                            {{item.name}}
                        </div>
                    </template>
                    <template v-slot:selection="{ item }">
                        <div style="display: flex; align-items: center; font-size: 14px">
                            <img :src="NodeIconMap[item.type]" :style="{transform: `scale(${item.scale})`, padding: `${item.padding}`}">
                            {{item.name}}
                        </div>
                    </template>
                </v-select>
            </div>
            <!--Filter by type name or token-->
            <div style="flex: 1">
                <div class="search-container">
                    <v-text-field
                        hide-details outlined
                        v-model="searchText"
                        :placeholder="$t('searchNode')"
                        @focusin="showMenu"
                        @focusout="hideMenu"
                        class="input-custom"
                    />
                    <img src="/img/scenario/search.svg" alt="search" class="search-icon">
                </div>
                <!--Menu select-->
                <div class="menu fci-scrollbar" v-if="show">
                    <div style="margin: 20px 0; font-size: 14px; color: #96ADD0; text-align: center" v-if="nodeListFilter.length === 0">{{$f.tc('noDataAvailable')}}</div>
                    <v-layout
                        v-for="node in nodeListFilter"
                        :key="node.id"
                        @mousedown="select(node)"
                        class="item"
                        :class="{active: node.id === activeId}"
                        align-center
                    >
                        <img :src="getSrcIconNode(node)" alt="icon" class="mr-2" style="width: 20px; height: 20px;">
                        {{ node.name }}
                        <span v-if="node.type === NodeType.PORTAL">( {{ portalSourceMap[node.id].name }} )</span>
                        <v-spacer></v-spacer>
                        <span class="node-id">{{ node.id }}</span>
                    </v-layout>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ScenarioService from "@/services/scenario.service";
import {mapState} from "vuex";

const {NodeIconMap, NodeType} = ScenarioService

export default {
    name: "ScenarioNodeFinder",
    props: {
        activeId: String
    },
    data() {
        return {
            NodeIconMap,
            NodeType,
            searchText: '',
            searchType: '',
            show: false
        }
    },
    computed: {
        ...mapState({
            nodeList: state => {
                let list = state.scenario.treeData ? state.scenario.treeData.nodeList : []
                return list.sort((a, b) => a.name.localeCompare(b.name))
            },
            portalSourceMap: state => state.scenario.portalSourceMap
        }),
        nodeListFilter() {
            let search = this.searchText.trim().toLowerCase()
            let type = this.searchType
            let listFilter = search  ? this.nodeList.filter(node => node.name.toLowerCase().includes(search) || node.id.includes(search)) : this.nodeList
            if (!type) return listFilter
            if (type === NodeType.FALLBACK) {
                listFilter = listFilter.filter(node => (node.type === NodeType.DECISION && node.is_fallback))
            } else if (type === NodeType.DECISION) {
                listFilter = listFilter.filter(node => (node.type === type && !node.is_fallback))
            } else {
                listFilter = listFilter.filter(node => node.type === type)
            }
            return listFilter
        },
        nodeTypes () {
            return [
                {
                    name: 'Decision',
                    type: NodeType.DECISION,
                    scale: '1',
                    padding: '0 12px 0 6px'
                },
                // {
                //     name: 'Form',
                //     type: NodeType.FORM,
                //     scale: '1.2',
                //     padding: '0 12px 0 6px'
                // },
                {
                    name: 'Portal',
                    type: NodeType.PORTAL,
                    scale: '0.85',
                    padding: '0 6px 0 0'
                },
                {
                    name: 'Process',
                    type: NodeType.PROCESS,
                    scale: '1.2',
                    padding: '0 12px 0 6px'
                },
                {
                    name: 'Link Scenario',
                    type: NodeType.LINK_SCENARIO,
                    scale: '0.85',
                    padding: '0 6px 0 0'
                },
                {
                    name: 'Supporter',
                    type: NodeType.SUPPORTER,
                    scale: '0.75',
                    padding: '0 8px 0 0'
                },
                {
                    name: 'Fallback',
                    type: NodeType.FALLBACK,
                    scale: '1.05',
                    padding: '0 12px 0 6px'
                }
                // {
                //     name: 'KB',
                //     type: NodeType.KB,
                //     scale: '1.2',
                //     padding: '0 12px 0 6px'
                // }
            ]
        }
    },
    methods: {
        select(node) {
            this.searchText = node.name
            this.$emit('change', node)
        },
        showMenu() {
            this.show = true
        },
        hideMenu() {
            this.show = false
        },
        getSrcIconNode (node) {
            if (node.type === NodeType.DECISION) {
                return node.is_fallback ? NodeIconMap[NodeType.FALLBACK] : NodeIconMap[node.type]
            } else return NodeIconMap[node.type]
        }
    }
}
</script>

<style scoped lang="scss">
.ScenarioNodeSelector {
    position: relative;
}

.item {
    cursor: pointer;
    font-size: 14px;
    font-family: "open sans";
    padding: 0 12px;
    height: 48px;
    border-bottom: 1px solid #e4edfa;

    &.active {
        background: #EEF6FF;
        color: #0052CC;

        .node-id {
            color: #0052CC;
        }
    }

    &:hover {
        background: #EEF6FF;
        color: #0052CC;

        .node-id {
            color: #0052CC;
        }
    }

    .node-id {
        color: #ccc;
    }
}

.item-type {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: "open sans";
}

.menu {
    position: absolute;
    top: 100%;
    right: 0;
    width: calc(100% - 218px);
    max-height: 400px;
    overflow: auto;
    background: #fff;
    box-shadow: 3px 3px 6px #0000000D;
}

.search-container {
    position: relative;
    min-width: 300px;
}

.search-icon {
    position: absolute;
    top: 5px;
    left: 10px;
    transform: scale(0.72);
}

.input-custom:not(.v-select) {
    ::v-deep .v-input__slot {
        padding: 6px 12px 6px 36px;
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            font-family: "open sans";
            padding: 0 6px 0 10px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }

        .v-label {
            background: #FFFFFF !important;
            padding: 0 6px;

            &:not(.v-label--active) {
                font-size: 14px !important;
                padding-left: 0 !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-list__tile--link:hover {
        background: #EEF6FF !important;
        color: #0052CC !important;
    }

    .v-list__tile {
        padding: 0 12px !important;
    }
}
</style>
